<span class="payment text-style">
  <div class="invoice-info" style="width: fit-content; height: fit-content">
    <mat-icon [color]="payment.paid ? 'accent' : 'warn'" class="fit-icon">
      {{ payment.paid ? 'check_circle' : 'error_outline' }}
    </mat-icon>
    <div class="invoice-date">
      <span class="date">{{ payment.invoiceDate | customDate }}</span>
      <span class="description" [class.error]="!payment.paid">
        {{ payment.paymentAmount | currency: (currencyCode$ | async) : 'symbol-narrow' : '1.2-2' : locale }} - {{ payment.treatingDoctor }}
      </span>
    </div>
  </div>
  <div class="actions">
    <button
      mat-flat-button
      [routerLink]="['/payments']"
      [queryParams]="{ hash: payment.hash }"
      [color]="payment.paid ? 'accent' : 'primary'"
      type="button"
      (click)="googleAnalytics($event)"
    >
      {{ paidButton }}
    </button>
  </div>
</span>
